import { buildApiRequest } from 'utils/api';
import { urls } from 'utils/urls';

const urlHelper = {
  vehicleStateRequest: (
    demandId,
    search = '',
    source = 'GPS',
    payload = {},
    minTonnage = '',
    maxTonnage = '',
    subscribed = '',
    searchCode = '',
  ) =>
    buildApiRequest(
      'GET',
      `${urls.getDemands}/${demandId}/op-search?operator-number=${search}&nonSubscribed=${subscribed}&source=${source}&minTonnage=${minTonnage}&maxTonnage=${maxTonnage}&operator-code=${searchCode}`,
      payload,
    ),
  deactivateFromApp: (demandId, payload) =>
    buildApiRequest('POST', `${urls.getDemands}/${demandId}/app-activate`, payload),
  markLessThanMktRate: (demandId, payload) =>
    buildApiRequest('POST', `${urls.getDemands}/${demandId}/mark-less-than-market-rate`, payload),
  fetchFOResponseConsignment: (code = '', page = 0, size = 20) =>
    buildApiRequest('GET', `${urls.operatorsList}/consignments?op-code=${code}&page=${page}&size=${size}`),
  fetchFOResponseQuotation: (code = '', extId = '', page = 0, size = 20) =>
    buildApiRequest('GET', `${urls.quotations}?op-code=${code}&operator-ext-id=${extId}&page=${page}&size=${size}`),
  fetchFOResponseVehicle: (code, demandId) =>
    buildApiRequest('GET', `${urls.operatorsList}/${code}/vehicles?demand-id=${demandId}`),
  fetchFeedbackConfig: () => buildApiRequest('GET', `${urls.quotations}/feedback/config`),
  fetchFeedbackValues: (code, demandId) =>
    buildApiRequest(
      'GET',
      // `${urls.quotations}/feedback?op-code=${code ? code : ''}&demand-id=${demandId}&operator-ext-id=${
      //   extId ? extId : ''
      // }`,
      `${urls.quotations}/feedback?op-code=${code ? code : ''}&demand-id=${demandId}`,
    ),
  fetchOperatorInfo: (code, demandId, extId) =>
    buildApiRequest(
      'GET',
      `${urls.operatorInfo}?op-code=${code || ''}&demand-id=${demandId}&operator-ext-id=${extId ? extId : ''}`,
    ),
  submitFeedback: (payload) => buildApiRequest('POST', `${urls.quotations}/feedback`, payload),
  initiateExotel: (code) => buildApiRequest('GET', `${urls.exotel}?op-code=${code}`),
  sendTokenAmountLink: (payload) => {
    return buildApiRequest('POST', `${urls.sendTokenLink}${payload.demandId}/initiate-payment-link`, payload);
  },
  sendNotification: (payload) => {
    return buildApiRequest(
      'GET',
      `${urls.sendNotification}op-freight-update-notif/${payload.demandId}?opCode=${payload.opCode}`
    );
  },
  retryTokenAmountLink: (payload) => {
    buildApiRequest('GET', `${urls.sendTokenLink}${payload.demandId}/retry-token-link?opCode=${payload.opCode}`);
  },
};

export default urlHelper;
